import { BrowserRouter } from "react-router-dom";
import { IntlProvider, addLocaleData } from "react-intl";
import { Provider } from "react-redux";
import Layout from "app/components/Layout";
import MuiThemeProvider from "material-ui/styles/MuiThemeProvider";
import React from "react";
import createStore from "app/redux/createStore";
import frLocaleData from "react-intl/locale-data/fr";
import getMuiTheme from "material-ui/styles/getMuiTheme";

addLocaleData([...frLocaleData]);

const store = createStore();

const muiTheme = getMuiTheme({
  fontFamily: "Lato, sans-serif",
  palette: {
    primary1Color: "#6cd4f7",
    accent1Color: "#143c2c",
    textColor: "#333"
  }
});

const App = props => (
  <Provider store={store}>
    <IntlProvider locale="fr" defaultLocale="fr">
      <MuiThemeProvider muiTheme={muiTheme}>
        <BrowserRouter>
          <Layout />
        </BrowserRouter>
      </MuiThemeProvider>
    </IntlProvider>
  </Provider>
);

export default App;



// WEBPACK FOOTER //
// ./src/app/components/App.js